export default __webpack_public_path__ + "static/media/download1.3ec4a4a3.png";